import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import TeamGridMember, { TeamGridMemberProps } from '../teamGridMember';
import "./teamGridModal.scss";

interface Props {
  onClose: () => void;
  member: TeamGridMemberProps;
}

const portalRoot = typeof document !== `undefined` ? document.getElementById('portal') : null;

const TeamGridModal: React.FC<Props> = (props) => {
  if (!portalRoot) {
    return null;
  }

  useEffect(() => {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };
  }, []);

  return ReactDOM.createPortal(
    <div className="team-grid-modal">
      {/* <button className="team-grid-modal__close" onClick={props.onClose} /> */}
      <div className="team-grid-modal__inner">
        <div className="team-grid-modal__content">
        <button className="team-grid-modal__close" onClick={props.onClose} />
        <TeamGridMember {...props.member} isTop />
        </div>
      </div>
    </div>,
    portalRoot
  );
};

export default TeamGridModal;
